module.exports = __webpack_public_path__ + "static/img/s34.1beef48d.png";